import { Box, Typography } from "@material-ui/core"
import React, { FunctionComponent } from "react"
import { MaxStorageRemainingLabel } from "./MaxStorageRemainingLabel"
import { StorageProgressBar } from "./StorageProgressBar"
import { StorageProgressLabel } from "./StorageProgressLabel"

interface StorageProgressCardProps {
    maxStorage: number
    currentStorage: number
    isCurrentYear: boolean
}

export const StorageProgressCard: FunctionComponent<StorageProgressCardProps> = ({
    maxStorage,
    currentStorage,
    isCurrentYear
}) => {
    return (
        <>
            <Box display="flex" alignItems="flex-start" flexDirection="column">
                <Box paddingBottom=".5em">
                    <Typography variant="body1">Total Storage</Typography>
                </Box>
                <Box paddingBottom=".5em">
                    {isCurrentYear && (
                        <MaxStorageRemainingLabel
                            maxStorage={maxStorage}
                            currentStorage={currentStorage}
                        />
                    )}
                </Box>
            </Box>
            <Box display="flex" alignItems="center">
                <Box flex={1} mr={1}>
                    <StorageProgressBar maxStorage={maxStorage} currentStorage={currentStorage} />
                </Box>
                <Box>
                    <StorageProgressLabel maxStorage={maxStorage} currentStorage={currentStorage} />
                </Box>
            </Box>
        </>
    )
}
